import React from 'react';
import tw from 'twin.macro';
import styled, { ThemeProvider } from 'styled-components';
import cn from 'classnames';
import useTheme from '@material-ui/core/styles/useTheme';
import Alert from '../../../../icons/Alert';

export type MenuSubItemProps = {
  icon?: React.ReactNode;
  label: string;
  selected?: boolean;
  color?: 'primary' | 'secondary';
  warning?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

export const MenuSubItem = ({
  icon,
  label,
  selected = false,
  color = 'secondary',
  warning,
  disabled,
  onClick,
}: MenuSubItemProps): JSX.Element => {
  const theme = useTheme();
  return (
    <ThemeProvider theme={theme}>
      <StyledDiv className={cn({ selected, warning, disabled })} onClick={onClick} color={color}>
        <div className="label labelSubItem">{label}</div>
        {warning || icon ? (
          <div className="pr-2">{warning ? <Alert color="#9a791b" width="18" strokeWidth="3" /> : icon}</div>
        ) : undefined}
      </StyledDiv>
    </ThemeProvider>
  );
};

const getTxtColor = (props: any) => {
  let selectedColor = props.theme.palette.text.secondary;
  if (props.color == 'primary') {
    selectedColor = props.theme.palette.text.primary;
  }
  return selectedColor;
};

const StyledDiv = styled.div`
  ${tw`flex justify-between items-center py-1 cursor-pointer`}
  color: ${(props) => getTxtColor(props)};

  .label {
    ${tw`ml-12 select-none`}
  }

  .labelSubItem {
    white-space: nowrap;
    margin-right: 0.5rem;
  }

  &.selected .label {
    ${tw`font-semibold`}
    color: ${(props) => props.theme.palette.primary.main};
  }

  &.warning {
    background-color: #fbf1d4;
  }

  &.disabled {
    opacity: 0.2;
    cursor: pointer;
    pointer-events: none;
  }
`;
